import { render, staticRenderFns } from "./ModelSet.vue?vue&type=template&id=61b1b5f0&scoped=true"
import script from "./ModelSet.vue?vue&type=script&lang=js"
export * from "./ModelSet.vue?vue&type=script&lang=js"
import style0 from "./ModelSet.vue?vue&type=style&index=0&id=61b1b5f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b1b5f0",
  null
  
)

export default component.exports